import { render, staticRenderFns } from "./goodsconfirm-check.vue?vue&type=template&id=06bad0d7&"
import script from "./goodsconfirm-check.vue?vue&type=script&lang=js&"
export * from "./goodsconfirm-check.vue?vue&type=script&lang=js&"
import style0 from "./goodsconfirm-check.vue?vue&type=style&index=0&id=06bad0d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports